/* eslint-disable */

/**
 * 发送异常数据到天罗
 * @param {*} params
 * 非必传参数:
    type_name:"type_name", //接口名称
    error_detail:"error_detail", //异常详情描述备注，这个是详细描述该异常，解释相应逻辑，需要带上相关的业务信息， 非必填，其值为：JSON格式字符串
    member_id:"member_id", //会员编码，如易购网站需要、则从cookie里取、变量名称为custno
    member_level:"member_level", //会员等级，如易购网站需要、则从cookie里取、变量名称为custLevel
    region:"region" //区域，如易购网站需要、则从cookie里取、变量名称为SN_CITY
 */

function sendMsg(params = {}) {
  if (!window.sa) {
    return;
  }
  try {
    if (window.sa && window.sa.openAPI && window.sa.openAPI.sendMsgV2) {
      const siteInfo = {
        bid: '', // 产品线标识，pplp-login， pplp-pay
        error_type: '2', // 异常类型，1：系统异常，2: 业务异常
        error_code: '', // 异常编码，业务异常对应的唯一编码
        status: '0', // 调用对应业务接口之后，对应请求响应的情况的状态码, 0：成功，1: 异常
      };
      window.sa.openAPI.sendMsgV2(Object.assign(siteInfo, params));
    }
  } catch (e) {
    throw new TypeError(e);
  }
}

export {
  sendMsg,
};
